// ─── RACHEL'S HAIR LOFT – theme.js ───────────────

document.addEventListener('DOMContentLoaded', function () {

  // ─── STICKY NAV SHADOW ────────────────────────
  const nav = document.getElementById('siteNav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ─── FADE-UP ANIMATIONS ──────────────────────
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

  // ─── FILTER BAR HIDE-ON-SCROLL ───────────────
  const filterBar = document.querySelector('.filter-bar');
  if (filterBar) {
    let lastScrollY = window.scrollY;
    let filterBarTop = filterBar.getBoundingClientRect().top + window.scrollY;

    window.addEventListener('scroll', () => {
      const currentY = window.scrollY;
      // Only hide once user has scrolled past the filter bar
      if (currentY > filterBarTop + 20) {
        if (currentY > lastScrollY) {
          // Scrolling down — hide
          filterBar.classList.add('filter-bar--hidden');
        } else {
          // Scrolling up — show
          filterBar.classList.remove('filter-bar--hidden');
        }
      }
      lastScrollY = currentY;
    }, { passive: true });
  }

  // ─── PRODUCT VARIANT SWITCHER + PRICE UPDATE ─
  // Load variants from the embedded JSON script tag
  const variantScriptEl = document.getElementById('product-variants-json');
  if (variantScriptEl) {
    try {
      window.__productVariants = JSON.parse(variantScriptEl.textContent);
    } catch(e) {
      window.__productVariants = [];
    }
  }

  const variantBtns = document.querySelectorAll('.variant-size-btn');

  function getSelectedOptions() {
    const groups = {};
    variantBtns.forEach(btn => {
      if (btn.classList.contains('active')) {
        groups[btn.dataset.optionIndex] = btn.dataset.optionValue;
      }
    });
    // Return as ordered array
    return Object.keys(groups).sort().map(k => groups[k]);
  }

  function updateVariantUI(match) {
    const form = document.getElementById('product-form');
    if (!form) return;

    // Update hidden variant ID
    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = match.id;

    // Update price display
    const priceSpan = document.getElementById('product-price');
    if (priceSpan && match.price != null) {
      priceSpan.textContent = (match.price / 100).toLocaleString('en-US', {
        style: 'currency', currency: 'USD'
      });
    }

    // Update compare-at price
    const compareSpan = document.getElementById('product-compare-price');
    if (compareSpan) {
      if (match.compare_at_price > match.price) {
        compareSpan.textContent = (match.compare_at_price / 100).toLocaleString('en-US', {
          style: 'currency', currency: 'USD'
        });
        compareSpan.style.display = 'inline';
      } else {
        compareSpan.style.display = 'none';
      }
    }

    // Update add to bag button availability
    const addBtn = document.getElementById('add-to-bag-btn');
    if (addBtn) {
      if (match.available) {
        addBtn.disabled = false;
        addBtn.style.opacity = '1';
        addBtn.innerHTML = '<i class="bi bi-bag-plus me-1"></i> Add to Bag';
      } else {
        addBtn.disabled = true;
        addBtn.style.opacity = '.5';
        addBtn.textContent = 'Sold Out';
      }
    }
  }

  variantBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const idx = this.dataset.optionIndex;

      // Deactivate siblings in same option group
      this.closest('.d-flex').querySelectorAll('.variant-size-btn').forEach(b => {
        b.classList.remove('active');
      });
      this.classList.add('active');

      // Update displayed option label
      const label = document.getElementById('option-val-' + (parseInt(idx) + 1));
      if (label) label.textContent = this.dataset.optionValue;

      // Find matching variant
      const allSelected = getSelectedOptions();
      const variantData = window.__productVariants || [];
      const match = variantData.find(v =>
        v.options.every((opt, i) => opt === allSelected[i])
      );
      if (match) updateVariantUI(match);
    });
  });

  // ─── CART: AJAX RENDER ───────────────────────

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderCartDrawer(cart) {
    const body    = document.getElementById('cart-drawer-body');
    const counter = document.getElementById('cart-drawer-count');
    if (!body) return;

    // Update header count
    if (counter) {
      counter.textContent = cart.item_count > 0
        ? `(${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'})`
        : '';
    }

    // Update nav badge(s)
    document.querySelectorAll('.cart-count:not(.wishlist-count)').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    });

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = `
        <div class="text-center" style="padding:3rem 0;">
          <i class="bi bi-bag" style="font-size:3rem; color:var(--brand-border);"></i>
          <p style="margin-top:1rem; color:var(--brand-muted);">Your bag is empty.</p>
          <a href="/collections/all" class="btn-brand mt-2 d-inline-block" data-bs-dismiss="offcanvas">
            Start Shopping
          </a>
        </div>`;
      return;
    }

    const itemsHtml = cart.items.map(item => {
      const imgSrc = item.image
        ? item.image.replace(/(\.\w+)$/, '_160x160$1')
        : '';
      const variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div style="font-size:.72rem; color:var(--brand-muted);">${item.variant_title}</div>`
        : '';
      return `
        <div class="cart-item">
          <img class="cart-item-img"
               src="${imgSrc}"
               alt="${item.title}"
               width="80" height="80"
               onerror="this.style.background='var(--brand-light)'">
          <div class="flex-grow-1">
            <div class="cart-item-name">${item.product_title}</div>
            ${variantLine}
            <div class="cart-item-price">${moneyFormat(item.final_price)}</div>
            <div class="d-flex align-items-center gap-2 mt-2">
              <button class="cart-qty-btn"
                      data-key="${item.key}"
                      data-qty="${item.quantity - 1}"
                      style="border:1px solid var(--brand-border); background:transparent; width:26px; height:26px;
                             display:inline-flex; align-items:center; justify-content:center; font-size:.9rem; cursor:pointer;">−</button>
              <span style="font-size:.85rem; min-width:16px; text-align:center;">${item.quantity}</span>
              <button class="cart-qty-btn"
                      data-key="${item.key}"
                      data-qty="${item.quantity + 1}"
                      style="border:1px solid var(--brand-border); background:transparent; width:26px; height:26px;
                             display:inline-flex; align-items:center; justify-content:center; font-size:.9rem; cursor:pointer;">+</button>
            </div>
          </div>
          <button class="cart-remove-btn"
                  data-key="${item.key}"
                  style="background:transparent; border:none; color:var(--brand-muted); cursor:pointer; font-size:1rem; padding:.25rem;"
                  aria-label="Remove ${item.title}">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>`;
    }).join('');

    body.innerHTML = `
      ${itemsHtml}
      <div style="display:flex; justify-content:space-between; padding:1.25rem 0; font-weight:600; border-top:1px solid var(--brand-border); margin-top:.5rem;">
        <span style="font-family:var(--font-display,serif); font-size:1.15rem; font-weight:400;">Subtotal</span>
        <span style="color:var(--brand-pink);">${moneyFormat(cart.total_price)}</span>
      </div>
      <p style="font-size:.75rem; color:var(--brand-muted); margin-bottom:1.5rem;">
        Shipping &amp; taxes calculated at checkout.
      </p>
      <a href="/checkout" class="btn-brand w-100 d-block text-center mb-2">
        Proceed to Checkout
      </a>
      <a href="/collections/all" class="btn-outline-brand w-100 d-block text-center" data-bs-dismiss="offcanvas">
        Continue Shopping
      </a>`;

    // Attach quantity + remove handlers to freshly rendered buttons
    body.querySelectorAll('.cart-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => cartUpdate(btn.dataset.key, parseInt(btn.dataset.qty)));
    });
    body.querySelectorAll('.cart-remove-btn').forEach(btn => {
      btn.addEventListener('click', () => cartUpdate(btn.dataset.key, 0));
    });
  }

  function cartUpdate(key, quantity) {
    // Optimistically disable buttons to prevent double-clicks
    const body = document.getElementById('cart-drawer-body');
    if (body) body.style.opacity = '.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(cart => {
      if (body) body.style.opacity = '1';
      renderCartDrawer(cart);
    })
    .catch(() => {
      if (body) body.style.opacity = '1';
    });
  }

  function cartAdd(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => fetch('/cart.js'))
    .then(r => r.json());
  }

  // Fetch and render current cart on page load (keeps count badge accurate)
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => renderCartDrawer(cart))
    .catch(() => {});

  // Re-render whenever cart offcanvas opens
  const cartOffcanvasEl = document.getElementById('cartOffcanvas');
  if (cartOffcanvasEl) {
    cartOffcanvasEl.addEventListener('show.bs.offcanvas', () => {
      fetch('/cart.js').then(r => r.json()).then(cart => renderCartDrawer(cart));
    });
  }

  // Add to Bag form submit
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = this.querySelector('[name="id"]').value;
      const addBtn = document.getElementById('add-to-bag-btn');
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

      cartAdd(variantId)
        .then(cart => {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.innerHTML = '<i class="bi bi-bag-plus me-1"></i> Add to Bag';
          }
          renderCartDrawer(cart);
          const cartEl = document.getElementById('cartOffcanvas');
          if (cartEl && window.bootstrap) {
            bootstrap.Offcanvas.getOrCreateInstance(cartEl).show();
          }
        })
        .catch(() => {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.innerHTML = '<i class="bi bi-bag-plus me-1"></i> Add to Bag';
          }
          productForm.submit(); // fallback
        });
    });
  }

  // ─── WISHLIST (localStorage) ─────────────────
  const WISHLIST_KEY = 'rhl_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch(e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function isWishlisted(productId) {
    return getWishlist().some(item => item.id === productId);
  }

  function toggleWishlistItem(productId, productTitle, productPrice, productImg, productUrl) {
    let list = getWishlist();
    const idx = list.findIndex(item => item.id === productId);
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push({ id: productId, title: productTitle, price: productPrice, img: productImg, url: productUrl });
    }
    saveWishlist(list);
    updateAllWishlistButtons();
    updateWishlistCount();
    renderWishlistPanel();
  }

  function updateAllWishlistButtons() {
    document.querySelectorAll('[data-wishlist-id]').forEach(btn => {
      const pid = btn.dataset.wishlistId;
      const icon = btn.querySelector('i');
      if (icon) {
        if (isWishlisted(pid)) {
          icon.className = 'bi bi-heart-fill';
          btn.style.color = 'var(--brand-pink)';
          btn.setAttribute('aria-label', 'Remove from wishlist');
        } else {
          icon.className = 'bi bi-heart';
          btn.style.color = '';
          btn.setAttribute('aria-label', 'Add to wishlist');
        }
      }
    });
  }

  function updateWishlistCount() {
    const list = getWishlist();
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = list.length;
      el.style.display = list.length > 0 ? 'inline-flex' : 'none';
    });
  }

  function renderWishlistPanel() {
    const container = document.getElementById('wishlist-items-container');
    if (!container) return;
    const list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = `
        <div class="text-center" style="padding:3rem 0;">
          <i class="bi bi-heart" style="font-size:3rem; color:var(--brand-border);"></i>
          <p style="margin-top:1rem; color:var(--brand-muted);">Your wishlist is empty.</p>
          <a href="/collections/all" class="btn-brand mt-2 d-inline-block" data-bs-dismiss="offcanvas">
            Start Shopping
          </a>
        </div>`;
      return;
    }
    container.innerHTML = list.map(item => `
      <div class="cart-item" data-wishlist-item-id="${item.id}">
        <img class="cart-item-img"
             src="${item.img || ''}"
             alt="${item.title}"
             width="80" height="80"
             onerror="this.style.background='var(--brand-light)'">
        <div class="flex-grow-1">
          <div class="cart-item-name">
            <a href="${item.url || '#'}" style="color:var(--brand-dark); text-decoration:none;">${item.title}</a>
          </div>
          <div class="cart-item-price">${item.price || ''}</div>
          <a href="${item.url || '#'}" class="btn-brand d-inline-block mt-2" style="font-size:.66rem; padding:.45rem 1rem;">
            View Product
          </a>
        </div>
        <button onclick="window.__rhlRemoveWishlist('${item.id}')"
                style="background:transparent; border:none; color:var(--brand-muted); cursor:pointer; font-size:1rem;"
                aria-label="Remove from wishlist">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>`).join('');
  }

  // Global helper for remove-from-wishlist inside rendered HTML
  window.__rhlRemoveWishlist = function(pid) {
    let list = getWishlist();
    saveWishlist(list.filter(item => item.id !== pid));
    updateAllWishlistButtons();
    updateWishlistCount();
    renderWishlistPanel();
  };

  // Attach click handlers to all wishlist buttons
  document.querySelectorAll('[data-wishlist-id]').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const pid    = this.dataset.wishlistId;
      const title  = this.dataset.wishlistTitle  || '';
      const price  = this.dataset.wishlistPrice  || '';
      const img    = this.dataset.wishlistImg    || '';
      const url    = this.dataset.wishlistUrl    || '';
      toggleWishlistItem(pid, title, price, img, url);
    });
  });

  // Open wishlist offcanvas from header heart icon
  const wishlistHeaderBtn = document.getElementById('wishlist-header-btn');
  if (wishlistHeaderBtn) {
    wishlistHeaderBtn.addEventListener('click', function(e) {
      e.preventDefault();
      renderWishlistPanel();
      const el = document.getElementById('wishlistOffcanvas');
      if (el && window.bootstrap) {
        bootstrap.Offcanvas.getOrCreateInstance(el).show();
      }
    });
  }

  // Init wishlist state on page load
  updateAllWishlistButtons();
  updateWishlistCount();
  renderWishlistPanel();

  // ─── SEARCH OFFCANVAS ────────────────────────
  const searchHeaderBtn = document.getElementById('search-header-btn');
  if (searchHeaderBtn) {
    searchHeaderBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const el = document.getElementById('searchOffcanvas');
      if (el && window.bootstrap) {
        const oc = bootstrap.Offcanvas.getOrCreateInstance(el);
        oc.show();
        // Auto-focus search input after transition
        el.addEventListener('shown.bs.offcanvas', () => {
          const input = el.querySelector('#search-input');
          if (input) input.focus();
        }, { once: true });
      }
    });
  }

  // ─── SEARCH OFFCANVAS ────────────────────────
  const searchInput   = document.getElementById('search-input');
  const searchResults = document.getElementById('search-results');
  const searchPopular = document.getElementById('search-popular');

  // Helper: close offcanvas then navigate
  function searchNavigate(url) {
    const oc = document.getElementById('searchOffcanvas');
    if (oc && window.bootstrap) {
      const instance = bootstrap.Offcanvas.getInstance(oc);
      if (instance) {
        oc.addEventListener('hidden.bs.offcanvas', () => { window.location.href = url; }, { once: true });
        instance.hide();
        return;
      }
    }
    window.location.href = url;
  }

  // Popular tag links — navigate properly
  if (searchPopular) {
    searchPopular.querySelectorAll('.search-popular-link').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        searchNavigate(this.href);
      });
    });
  }

  if (searchInput && searchResults) {
    let searchTimer;

    function renderResults(products) {
      // Hide popular when results showing
      if (searchPopular) searchPopular.style.display = products.length > 0 ? 'none' : '';

      if (products.length === 0) {
        searchResults.innerHTML = `
          <div style="padding:1.5rem 0; text-align:center; color:var(--brand-muted); font-size:.88rem;">
            <i class="bi bi-search" style="font-size:1.5rem; display:block; margin-bottom:.5rem; opacity:.4;"></i>
            No results found.
          </div>`;
        return;
      }

      searchResults.innerHTML = products.map(p => {
        const img  = p.featured_image?.url || '';
        const price = p.price ? '$' + (p.price / 100).toFixed(2) : '';
        return `
          <div class="sr-item" data-url="${p.url}">
            <div class="sr-item-img">
              ${img ? `<img src="${img}" alt="${p.title}" width="72" height="72">` : ''}
            </div>
            <div class="sr-item-body">
              <div class="sr-item-title">${p.title}</div>
              ${price ? `<div class="sr-item-price">${price}</div>` : ''}
            </div>
            <i class="bi bi-arrow-right sr-item-arrow"></i>
          </div>`;
      }).join('');

      // Attach click handlers to freshly rendered items
      searchResults.querySelectorAll('.sr-item').forEach(item => {
        item.addEventListener('click', function() {
          searchNavigate(this.dataset.url);
        });
      });

      // View all link
      const q = searchInput.value.trim();
      searchResults.insertAdjacentHTML('beforeend', `
        <div class="sr-view-all" data-url="/search?q=${encodeURIComponent(q)}&type=product">
          <span>View all results for "<em>${q}</em>"</span>
          <i class="bi bi-arrow-right"></i>
        </div>`);
      searchResults.querySelector('.sr-view-all').addEventListener('click', function() {
        searchNavigate(this.dataset.url);
      });
    }

    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimer);
      const q = this.value.trim();
      if (q.length < 2) {
        searchResults.innerHTML = '';
        if (searchPopular) searchPopular.style.display = '';
        return;
      }
      searchTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
          .then(r => r.json())
          .then(data => renderResults(data?.resources?.results?.products || []))
          .catch(() => {
            searchResults.innerHTML = `<p style="padding:1rem; color:var(--brand-muted); font-size:.85rem;">Search unavailable.</p>`;
          });
      }, 300);
    });

    // Form submit — navigate to full search page
    const searchForm = document.getElementById('search-form');
    if (searchForm) {
      searchForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const q = searchInput.value.trim();
        if (q) searchNavigate(`/search?q=${encodeURIComponent(q)}&type=product`);
      });
    }
  }

});
